import { IonContent, IonPage } from '@ionic/react'
import classNames from 'classnames'
import { ReactNode } from 'react'

import { MODAL_WRAPPER_X_PADDING } from '@apps-common/components/modals/modal/ModalContainer'

interface IProps {
  children: ReactNode
  classes?: string
}

export const ModalBodyInfiniteScrollable: React.FC<IProps> = ({ children, classes }) => (
  <IonPage>
    <IonContent
      forceOverscroll={false}
      style={{
        '--background': 'transparent'
      }}
    >
      <div
        className={classNames(
          MODAL_WRAPPER_X_PADDING,
          'safe-area-top w-full h-[100%] scrollbar-none pb-[calc(96px+max(env(safe-area-inset-bottom),0px))] sm:pb-[80px]',
          classes
        )}
      >
        {children}
      </div>
    </IonContent>
  </IonPage>
)
